/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { Section } from '../../../styles/layout/Section';
import { CtaButton } from '../../../styles/ui/Button';

// Aba padronizada no kit FC7 (antes: variante local com #0288d1).
export { TabButton } from '../../../styles/ui/Button';

export const FiltersSection = styled(Section)`
   position: sticky;
   top: 0;
   z-index: 5;
`;

export const TabBar = styled.nav`
   display: flex;
   flex-wrap: wrap;
   gap: 4px;
   margin-bottom: 16px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
   padding-bottom: 0;
   overflow-x: auto;
`;

export const SubGroup = styled.div`
   margin-bottom: 18px;

   &:last-child {
      margin-bottom: 0;
   }
`;

export const SubGroupTitle = styled.h3`
   font-size: 12px;
   font-weight: 700;
   text-transform: uppercase;
   letter-spacing: 0.6px;
   color: #888;
   margin: 0 0 10px;
`;

export const MetricsRow = styled.div`
   display: grid;
   grid-template-columns: repeat(${({ $cols }) => $cols ?? 4}, 1fr);
   gap: 12px;

   @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
   }

   @media (max-width: 480px) {
      grid-template-columns: 1fr;
   }
`;

export const MetricCard = styled.div`
   background: #fff;
   border-radius: 10px;
   border: 1px solid
      ${({ $alert }) => ($alert ? '#ef5350' : 'rgba(0, 0, 0, 0.08)')};
   padding: 14px 16px;
   display: flex;
   flex-direction: column;
   gap: 4px;
   min-height: 90px;
`;

export const MetricLabel = styled.span`
   font-size: 11px;
   font-weight: 700;
   color: #888;
   text-transform: uppercase;
   letter-spacing: 0.4px;
`;

export const MetricValue = styled.span`
   font-size: 22px;
   font-weight: 800;
   color: ${({ $color }) => $color ?? '#222'};
   line-height: 1.2;
`;

export const MetricSub = styled.span`
   font-size: 11px;
   color: #aaa;
`;

export const DeltaBadge = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 3px;
   font-size: 12px;
   font-weight: 700;
   color: ${({ $color }) => $color};
`;

export const FreelanceTag = styled.span`
   display: inline-block;
   font-size: 10px;
   font-weight: 700;
   color: #7b1fa2;
   background: #f3e5f5;
   border-radius: 4px;
   padding: 2px 6px;
   margin-left: 6px;
   text-transform: uppercase;
   letter-spacing: 0.3px;
`;

export const ChartCard = styled.div`
   background: #fff;
   border-radius: 10px;
   border: 1px solid rgba(0, 0, 0, 0.08);
   padding: 16px 20px;
   margin-bottom: 14px;

   &:last-child {
      margin-bottom: 0;
   }
`;

export const ChartsRow = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 14px;
   margin-bottom: 14px;

   @media (max-width: 900px) {
      grid-template-columns: 1fr;
   }
`;

export const ChartTitle = styled.h3`
   margin: 0 0 4px;
   font-size: 14px;
   font-weight: 700;
   color: #333;
`;

export const ChartSub = styled.p`
   margin: 0 0 16px;
   font-size: 11px;
   color: #aaa;
`;

export const EmptyState = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 48px 0;
   color: #aaa;
   font-size: 14px;
   gap: 8px;
   text-align: center;
`;

// Pesquisar = ação consultiva → CTA escuro (regra FC7)
export const SearchButton = styled(CtaButton)`
   width: 100%;
`;

export const PendingAlert = styled.div`
   background: #fff8e1;
   border: 1px solid #ffe082;
   border-radius: 10px;
   padding: 10px 14px;
   margin-bottom: 14px;
   font-size: 13px;
   color: #6d4c00;

   strong {
      color: #b06a00;
   }
`;

export const StubBox = styled.div`
   background: #fafafa;
   border: 1px dashed rgba(0, 0, 0, 0.15);
   border-radius: 10px;
   padding: 48px 16px;
   text-align: center;
   color: #888;
   font-size: 14px;
`;
